import React from 'react';
import { Link } from 'react-router-dom'
import logoImg from "../../../images/bubble-logo.png"
import { BiMenuAltLeft } from "react-icons/bi";
import { BiMenuAltRight } from "react-icons/bi";
import ThemeToggle from "../Theme/ThemeToggle";
import {AuthHeaderStyled} from "../../../styled/Header";
import {useTheme} from "../Theme/ThemeContext";
import NotificationBell from "../NotificationBell/NotificationBell";
import Dropdown from "../Dropdown/Dropdown";
import { ButtonThin } from "../Buttons/Buttons";
import { useNavigate } from 'react-router-dom';
import useNotifications from '../../../hooks/useNotifications';
import { formatRelativeTime } from '../../../utils/dates';

const AuthHeader = (props) => {
    const isIOSStandalonePWA = () => {
        // Check if iOS (iPhone/iPad/iPod)
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

        // Check if in standalone mode
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone ||
            document.referrer.includes('android-app://');

        return isIOS && isStandalone;
    }
    const {themeName} = useTheme();
    const navigate = useNavigate();
    const { unreadCount, preview, markAllRead, markOneRead } = useNotifications({ limit: 50 });

    const dropdownItems = [
        { value: '__header', className: 'dropdown-header', label: (<div>Notifications</div>) },
        ...preview.map(n => {
            const preview = (n.description || '').trim();
            const short = preview.length > 60 ? preview.slice(0, 60) + '…' : preview;
            return ({
                value: n._id,
                className: 'notification-item',
                label: (
                    <a href={n.url || '/'} onClick={() => markOneRead(n._id)} style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column' }}>
                        <span className="notification-title" style={{ fontWeight: n.status === 'unread' ? 700 : 500 }}>{n.title}</span>
                        {short && <span className="notification-body">{short}</span>}
                        <span className="notification-meta" style={{ alignSelf: 'flex-end' }}>{formatRelativeTime(n.createdAt)}</span>
                    </a>
                )
            })
        }),
        ...(preview.length > 0 ? [{
            value: '__footer',
            className: 'dropdown-footer',
            label: (
                <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                    <ButtonThin border={`1px solid #6FCBD1`} color={'#0B1A21'} width={'100%'} height={'30px'} onClick={() => navigate('/user/dashboard/notifications')}>
                        Show all
                    </ButtonThin>
                    <ButtonThin border={`1px solid #EE7B1C`} bgColor={'transparent'} color={themeName === 'dark' ? '#fff' : '#0B1A21'} width={'100%'} height={'30px'} onClick={markAllRead}>
                        Mark all read
                    </ButtonThin>
                </div>
            )
        }] : [])
    ];
    return (
        <div style={{width: '95%!important', margin: '0 auto'}}>

            <AuthHeaderStyled className="auth-header" mobileApps={isIOSStandalonePWA()} theme={themeName}>
                <div className="logo">
                    <Link to='/'>
                        <img src={logoImg} alt='Bubble Ai' className="authLogo"/>
                    </Link>
                </div>


                <div className="rightItems">
                    <ThemeToggle/>
                  
                    <Dropdown
                        trigger={<NotificationBell number={unreadCount}/>}
                        menuClassName="BubblePopIn"
                        items={dropdownItems}
                        onSelect={() => {}}
                    />

                    <div
                        className={!props.authMenuOpen ? 'showOptions' : 'hideOptions'}
                        onClick={props.onClick}
                        aria-label={props.authMenuOpen ? 'Close menu' : 'Open menu'}
                    >
                        {!props.noAuthMenu && (
                            props.authMenuOpen ? (
                                <BiMenuAltLeft size='2.5em' color="#6FCBD1" />
                            ) : (
                                <BiMenuAltRight size='2.5em' color="#6FCBD1" />
                            )
                        )}
                    </div>
                </div>
            </AuthHeaderStyled>
        </div>

    )
}

export default AuthHeader;